export default __webpack_public_path__ + "static/desktop_KV13-d0e28b7756ada8da9ddaaa8785af8bb8.mp4";